<div class="menu-container">

    <div class="menu-header">
        <div class="back-arrow">
            <button class="dotted-arrow" mat-icon-button (click)="closeAddToQuote()">←</button>
        </div>
        <h3 class="headline" i18n="@@add-to-quote_add-to-quote">Add To Quote</h3>
    </div>

    <div class="menu-actions" [formGroup]="form">
        <div i18n="@@add-to-quote_create-new-quote" class="btn-action menu-action create-quote" (click)="createQuote()">
            <div>Create new quote</div>
            <div class="create-new-symbol">+</div>
        </div>

        <div *ngIf="selectedQuote; else noQuoteSelected" class="btn-action menu-action selected-quote" (click)="selectNewQuote()">
            <div>{{selectedQuote.name}}</div>
            <mat-icon class="select-quote-arrow">arrow_forward_ios</mat-icon>
            <mat-spinner *ngIf="isLoading" [diameter]="26"></mat-spinner>
        </div>
        <ng-template #noQuoteSelected>
            <div class="btn-action menu-action selected-quote" (click)="selectNewQuote()">
                <div i18n="@@add-to-quote_quote">Choose Quote</div>
                <mat-icon class="select-quote-arrow">arrow_forward_ios</mat-icon>
                <mat-spinner *ngIf="isLoading" [diameter]="26"></mat-spinner>
            </div>
        </ng-template>

        <div class="menu-action quantity-box">
            <div i18n="@@add-to-quote_quantity" class="quantity-title">Quantity</div>
            <input (change)="changeQuantity()" class="quantity-input" type="number" min="1" max="999"
                   placeholder="quantity" formControlName="quantity"/>
        </div>

        <span fxLayoutAlign="center" *ngIf="form.controls.quantity.errors" i18n="@@add-to-quote_error-quantity_min-max">Please enter a quantity between 1 and 999</span>
    </div>

    <div class="product-information">
        <div class="product-img">
            <img alt="product-thumbnail" src="{{product.thumbnailUrl}}">
        </div>

        <div class="product-metadata">
            <div>{{product.decor?.label}}</div>
            <div>{{product.name}}</div>
            <div>{{product.sku}}</div>
        </div>
    </div>


    <div class="menu-footer">
        <div class="product-action-buttons">
            <button i18n="@@add-to-quote_cancel-button" class="btn-primary main-btn cancel-btn"
                    (click)="closeAddToQuote()">
                Cancel
            </button>
            <button i18n="@@add-to-quote_add-button" class="btn-primary main-btn add-btn"
                    [disabled]="isLoading" (click)="addProduct()">
                Add
            </button>
        </div>
    </div>
</div>
